import { forEach } from '@angular/router/src/utils/collection';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ServiceService } from '../../services/service.service';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs/Rx';

declare var $: any;
declare var MathJax: any;

@Component({
	selector: 'app-soal',
	templateUrl: './soal.component.html',
	styleUrls: ['./soal.component.css']
})
export class SoalComponent implements OnInit, OnDestroy {

	user: any;
	soal: any;
	nilai: any;
	extra: any;
	setting: any;
	kategori: any;
	soalSekarang: number;
	totalSoal: number;
	jumlahBenar: number;
	skor: number;
	waktu: number;
	warna: any = { A: "lightblue", B: "green", C: "yellow", D: "red", E: "indigo" };
	jawaban: string[] = [];
	waktuHabis: Date;

	private diff: number;
	private $counter: Observable<number>;
	private subscription: Subscription;
	private sisaWaktu: string;

	constructor(private router: Router, private service: ServiceService) {
		this.user = this.service.checkLogin();
		this.extra = this.service.getExtra();
		this.soal = this.service.getSoal();
		this.nilai = this.service.getNilai();
		this.setting = this.service.getSetting();
		this.kategori = this.service.getKategori();
		this.soalSekarang = this.extra.soal_terakhir;
		this.totalSoal = this.extra.total_soal;
		this.skor = this.extra.skor;
		this.waktu = this.extra.sisa_waktu;
		for (let i = 65; i < 65 + parseInt(this.setting.jumlah_jawaban); i++) {
			this.jawaban.push(String.fromCharCode(i));
		}
	}

	ngOnInit() {
		if (this.extra.sisa_waktu == null) {
			this.router.navigate(['/quisioner']);
		}
		this.mulaiTimer();
		this.jquery();
	}

	/* tinggal10Detik(){
	  this.waktuHabis = new Date(new Date().getTime() + 10000);
	} */

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	mulaiTimer() {
		this.waktuHabis = new Date(new Date().getTime() + (this.waktu * 1000));
		this.$counter = Observable.interval(1000).map((x) => {
			this.diff = Math.floor((this.waktuHabis.getTime() - new Date().getTime()) / 1000);
			if (this.diff < 0) {
				this.subscription.unsubscribe();
				console.log("Waktu habis..");
				this.simpanAkhir();
			}
			if (this.diff % 30 == 0) {
				this.simpanJawaban();
			}
			return x;
		});
		this.subscription = this.$counter.subscribe((x) => this.sisaWaktu = this.dhms(this.diff));
	}

	lanjutSoal() {
		this.soalSekarang += 1;
		$('.mjx-chtml').remove();
		this.simpanJawaban();
	}

	kembaliSoal() {
		this.soalSekarang -= 1;
		$('.mjx-chtml').remove();
		this.simpanJawaban();
	}

	pindahSoal(idx) {
		if (this.soalSekarang != idx) {
			this.soalSekarang = idx;
			this.jquery();
			this.simpanJawaban();
		}
	}

	pindahSimpan() {
		this.soalSekarang = this.nilai.length;
		this.simpanJawaban();
	}

	simpanJawaban() {
		// Simpan data
		// console.log("Simpan...");
		this.extra.soal_terakhir = this.soalSekarang;
		this.extra.total_soal = this.totalSoal;
		this.extra.skor = this.skor;
		this.extra.sisa_waktu = this.diff;
		this.service.setNilai(this.nilai);
		this.service.setExtra(this.extra);
		// Kirim ke server
		this.service.serviceSimpanJawaban().subscribe(data => {
			if (data.success) {
				console.log("Berhasil Disimpan..");
			} else {
				console.log("Gagal..");
			}
		});
	}

	actionSimpanAkhir(btnSimpan) {
		$(btnSimpan).prop('disabled', true);
		$(btnSimpan).find('i').addClass('fa-circle-o-notch fa-spin');
		this.simpanAkhir();
	}

	simpanAkhir() {
		this.extra.soal_terakhir = this.soalSekarang;
		this.extra.total_soal = this.totalSoal;
		this.extra.skor = this.skor;
		this.extra.sisa_waktu = this.diff;
		this.service.setNilai(this.nilai);
		this.service.setExtra(this.extra);
		// Kirim ke server
		this.service.serviceSimpanAkhir().subscribe(data => {
			if (data.success) {
				console.log("Berhasil Disimpan...");
				this.service.setExtra(data.extra);
				this.router.navigate(['/quisioner']);
			} else {
				console.log("Gagal...");
			}
		});
	}

	getKategori(id) {
		return (this.kategori.filter(item => item.kategori_id == id)[0].kategori_nama).toUpperCase();
	}

	pad(str, max) {
		str = str.toString();
		return str.length < max ? this.pad("0" + str, max) : str;
	}

	dhms(t) {
		var days, hours, minutes, seconds;
		days = Math.floor(t / 86400);
		t -= days * 86400;
		hours = Math.floor(t / 3600) % 24;
		t -= hours * 3600;
		minutes = Math.floor(t / 60) % 60;
		t -= minutes * 60;
		seconds = t % 60;

		return [
			days > 0 ? days + ' Hari' : '',
			days > 0 || hours > 0 ? hours + ' Jam' : '',
			days > 0 || hours > 0 || minutes > 0 ? minutes + ' Menit' : '',
			seconds + ' Detik'
		].join(' ');
	}

	jquery() {
		$('.soalpoin span').remove();
		$('.soalpoin script').remove();

		setTimeout(() => {
			MathJax.Hub.Queue(["Typeset", MathJax.Hub]);

			$('.img-link').magnificPopup({ type: 'image' });
			$(".pmd-radio-ripple-effect").on('mousedown', function (e) {
				var rippler = $(this);
				$('.ink').remove();
				// create .ink element if it doesn't exist
				if (rippler.find(".ink").length === 0) {
					rippler.append('<span class="ink"></span>');
				}
				var ink = rippler.find(".ink");
				// prevent quick double clicks
				ink.removeClass("animate");
				// set .ink diametr
				if (!ink.height() && !ink.width()) {
					// var d = Math.max(rippler.outerWidth(), rippler.outerHeight());
					ink.css({ height: 15, width: 15 });
				}
				// get click coordinates
				var x = e.pageX - rippler.offset().left - ink.width() / 2;
				var y = e.pageY - rippler.offset().top - ink.height() / 2;
				// set .ink position and add class .animate
				ink.css({
					top: y + 'px',
					left: x + 'px'
				}).addClass("animate");
				setTimeout(function () {
					ink.remove();
				}, 1500);
			});
		}, 0);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/soal/soal.component.ts